import { Controller } from "@hotwired/stimulus";

const OKTA_HOSTNAME = /(^|\.)(okta|oktapreview|okta-emea)\.com$/i;

export default class extends Controller {
  static targets = ["aud", "specVersion"];

  overridden() {
    this.overriddenByUser = true;
  }

  suggestSpecVersion() {
    if (this.overriddenByUser) return;

    this.specVersionTarget.value = this.oktaAud() ? "draft" : "v1_0";
  }

  oktaAud() {
    const hostname = this.audHostname();
    return hostname !== null && OKTA_HOSTNAME.test(hostname);
  }

  audHostname() {
    const value = this.audTarget.value.trim();
    if (!value) return null;

    try {
      return new URL(/^[a-z]+:\/\//i.test(value) ? value : `https://${value}`).hostname;
    } catch {
      return null;
    }
  }
}
